const GET_CONSTANT = '/constant';
const EVENT_MASTER = '/event-master';
const CANDIDATE_LOGIN = '/candidate/auth/login';
const CANDIDATE_CHECK_EMAIL = '/candidate/auth/check-email';
const CANDIDATE_REGISTER = '/candidate/auth/register';
const CANDIDATE_CONFIRM_MAIL = '/candidate/confirm';
const CANDIDATE_ME = '/candidate/auth/me';
const CANDIDATE_UPDATE_APPLICANT_INFO = '/candidate/update/applicant';
const CANDIDATE_UPDATE_APPLICANT_ENTRY = '/candidate/update/applicant-entry';
const CANDIDATE_UPDATE_SCOUT_MAIL = '/candidate/update/scout-mail';
const CANDIDATE_UPDATE_READ_FLAG_NOTIFICATION =
  '/candidate/update-read-flag/notification-applicant';
const CANDIDATE_UPDATE_DISPLAY_FLAG_NOTIFICATION =
  '/candidate/update-display-flag/notification-applicant';
const CANDIDATE_UPDATE_READ_FLAG_INFO_LOG_APPLICANT =
  '/candidate/update-read-flag/info-log-applicant';
const CANDIDATE_UPDATE_DISPLAY_FLAG_INFO_LOG_APPLICANT =
  '/candidate/update-display-flag/info-log-applicant';
const CANDIDATE_INTERVIEW_SCHEDULE = '/candidate/interview-schedule';
const LOG = '/log';
const CANDIDATE_APPLY_OR_CANCEL_INTERVIEW =
  '/candidate/apply-or-cancel-interview';
const CANDIDATE_APPLICANT_INTERVIEW_STATUS =
  '/candidate/applicant-interview-status';
const CANDIDATE_SORT_APPLICANT_INTERVIEW_STATUS =
  '/candidate/sort-applicant-interview-status';

const COMPANY_LIST_COMPANY = '/company/list-company';
const COMPANY_ACTION_FAVORITE_COMPANY = '/company/favorite-company';
const COMPANY_INFO_COMPANY = '/company/info';
const COMPANY_CHECK_IN = '/checkin-company';

const RECEPTION_LOGIN = '/reception/auth/login';
const RECEPTION_CHECK_IN = '/checkin-event';
const RECEPTION_LIST_CHECK_IN = '/reception/auth/list-checkin-event';

const SEND_QUESTION_EVENT = '/candidate/event-question';

const LANDING_PAGE_LINK = '/landing-page/link';
const LANDING_PAGE_COMPANY_DETAIL = '/landing-page/company-detail';
const LANDING_PAGE_EVENT = '/landing-page/event';
const LANDING_PAGE_GET_SCHEDULE = '/landing-page/get-schedule';
// HungPD add 2023_10_08 Start
const SIGN_S3 = '/sign-s3';
// HungPD add 2023_10_08 End
export default {
  GET_CONSTANT,
  EVENT_MASTER,
  CANDIDATE_LOGIN,
  CANDIDATE_CHECK_EMAIL,
  CANDIDATE_REGISTER,
  CANDIDATE_CONFIRM_MAIL,
  CANDIDATE_ME,
  CANDIDATE_UPDATE_APPLICANT_INFO,
  CANDIDATE_UPDATE_APPLICANT_ENTRY,
  CANDIDATE_UPDATE_SCOUT_MAIL,
  CANDIDATE_UPDATE_READ_FLAG_NOTIFICATION,
  CANDIDATE_UPDATE_DISPLAY_FLAG_NOTIFICATION,
  CANDIDATE_UPDATE_READ_FLAG_INFO_LOG_APPLICANT,
  CANDIDATE_UPDATE_DISPLAY_FLAG_INFO_LOG_APPLICANT,
  CANDIDATE_INTERVIEW_SCHEDULE,
  LOG,
  CANDIDATE_APPLY_OR_CANCEL_INTERVIEW,
  CANDIDATE_APPLICANT_INTERVIEW_STATUS,
  CANDIDATE_SORT_APPLICANT_INTERVIEW_STATUS,

  COMPANY_LIST_COMPANY,
  COMPANY_ACTION_FAVORITE_COMPANY,
  COMPANY_INFO_COMPANY,
  COMPANY_CHECK_IN,

  RECEPTION_LOGIN,
  RECEPTION_CHECK_IN,
  RECEPTION_LIST_CHECK_IN,
  SEND_QUESTION_EVENT,

  LANDING_PAGE_LINK,
  LANDING_PAGE_COMPANY_DETAIL,
  LANDING_PAGE_EVENT,
  LANDING_PAGE_GET_SCHEDULE,

  // HungPD add 2023_10_08 Start
  SIGN_S3
  // HungPD add 2023_10_08 End
};
